"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderFile = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_dropzone_1 = require("react-dropzone");
const bi_1 = require("react-icons/bi");
const ErrorMessage_1 = __importDefault(require("./ErrorMessage"));
const DropzoneMedia = ({ setFiles, label = "Sélectionnez un fichier", maxFiles = 1, customClassContainer = "", acceptFile, icon, }) => {
    const [acceptedFiles, setAcceptedFiles] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)("");
    const onDrop = (0, react_1.useCallback)((files, rejections) => {
        if (files.length > 0) {
            // On ne garde qu'un seul fichier
            const newFile = files[0];
            setAcceptedFiles([newFile]);
            setFiles === null || setFiles === void 0 ? void 0 : setFiles(newFile);
        }
        rejections.forEach((rej) => {
            rej.errors.forEach((err) => {
                if (err.code === "file-invalid-type") {
                    setError("Type de fichier non autorisé.");
                }
                if (err.code === "file-too-large") {
                    setError("Fichier trop volumineux.");
                }
            });
        });
    }, [setFiles]);
    const { getRootProps, getInputProps } = (0, react_dropzone_1.useDropzone)({
        onDrop,
        maxFiles,
        maxSize: 109715200, // ~104 Mo
        accept: acceptFile,
    });
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => setError(""), 3000);
        return () => clearTimeout(timeout);
    }, [error]);
    return (react_1.default.createElement("section", { className: "dropzone files_dropzone w-100" },
        react_1.default.createElement("div", Object.assign({}, getRootProps(), { style: {
                border: "1px solid #0088CE",
                borderRadius: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "2rem 15px",
                background: "transparent",
                cursor: "pointer",
            }, className: `dashed text-center ${customClassContainer}` }),
            react_1.default.createElement("input", Object.assign({}, getInputProps(), { type: "file", name: "dropzone_files", id: "__dropzone_files" })),
            react_1.default.createElement("div", { className: "flex-c align-items-center mb-3 gap-3" }, icon),
            react_1.default.createElement("span", { style: { color: "#A6A6A6", fontWeight: 400, fontFamily: "Inter", fontSize: "15px" } }, label)),
        error && react_1.default.createElement(ErrorMessage_1.default, { message: error }),
        acceptedFiles.length > 0 && (react_1.default.createElement("div", { className: "pt-3 d-flex align-items-center justify-content-between" },
            react_1.default.createElement("span", { className: "text-truncate" }, acceptedFiles[0].name),
            react_1.default.createElement("button", { className: "btn btn-sm", onClick: () => {
                    setAcceptedFiles([]);
                    setFiles === null || setFiles === void 0 ? void 0 : setFiles(null);
                } },
                react_1.default.createElement(bi_1.BiTrash, { color: "#ff0000", size: 20 }))))));
};
exports.default = DropzoneMedia;
const RenderFile = ({ file }) => {
    const fileURL = URL.createObjectURL(file);
    if (file.type.startsWith("image/")) {
        return (react_1.default.createElement("img", { src: fileURL, alt: file.name, style: { width: "100%", height: "auto", borderRadius: "8px" } }));
    }
    else if (file.type.startsWith("video/")) {
        return (react_1.default.createElement("video", { src: fileURL, controls: true, style: { width: "100%", borderRadius: "8px" } }));
    }
    else if (file.type.startsWith("audio/")) {
        return (react_1.default.createElement("audio", { src: fileURL, controls: true, style: { width: "100%" } }));
    }
    else {
        return react_1.default.createElement("span", null, file.name);
    }
};
exports.RenderFile = RenderFile;
